export default "__VITE_ASSET__DSIvwToz__"